import { IStackStyles } from "@fluentui/react";

export const linkWrapperStyles: IStackStyles = {
    root: {
        maxWidth: "fit-content"
    }
};
